import React, { useState } from "react"
import { MinusIcon, PlusIcon } from "components/page-components/Icons/small"

export const LeistungsartListCard = ({ category }) => {
  const [showMore, setShowMore] = useState(false)

  const toggleMore = () => setShowMore(!showMore)

  return (
    <div className="card">
      <div className="card-header">
        <p className="title is-5 has-text-auftragsvolumendunkelgruen py-3 px-4">
          {category.name}
        </p>
      </div>
      <div
        className="card-content"
        style={{
          transition: "all .3s ease",
          maxHeight: showMore ? "1100px" : "170px",
          overflowY: showMore ? "" : "hidden",
        }}
      >
        <div className="content">
          <ul className="mt-0">
            {category.list_items.map((item, index) => (
              <li key={`leistungsart-list-item-${index}`}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="card-footer">
        {category.list_items.length > 4 ? (
          <button
            onClick={toggleMore}
            className="button is-tertiary is-fullwidth"
          >
            <span>{showMore ? "Weniger anzeigen" : "Mehr anzeigen"}</span>
            <span className="icon">
              {showMore ? (
                <MinusIcon {...{ size: 0.9 }} />
              ) : (
                <PlusIcon {...{ size: 0.9 }} />
              )}
            </span>
          </button>
        ) : (
          <button
            className="button is-tertiary is-fake"
            aria-label="Leistungsarten"
          >
            <span></span>
            <span className="icon"></span>
          </button>
        )}
      </div>
    </div>
  )
}
